<template>
  <section class="editor-block" v-if="data && data.content">
    <div class="editor-block__container">
      <div
          class="editor-block__content ql-editor"
          v-html="processedContent"
      />
    </div>
  </section>
</template>

<script>
export default {
  name: 'AppEditorBlock',
  props: {
    data: {
      type: Object,
      required: true,
      default: () => ({})
    }
  },
  computed: {
    processedContent() {
      if (!this.data.content) return '';

      let html = this.data.content;

      html = html.replace(/<img([^>]*)style="[^"]*width:\s*0px[^"]*"([^>]*)>/g, (match) => {
        let newStyle = match.match(/style="([^"]*)"/)?.[1] || '';
        newStyle = newStyle.replace(/width:\s*0px;?\s*/g, '');
        newStyle = newStyle.replace(/height:\s*0px;?\s*/g, '');
        newStyle = newStyle.replace(/cursor:\s*se-resize;?\s*/g, '');

        // Если после удаления остались другие стили
        if (newStyle.trim()) {
          return match.replace(/style="[^"]*"/, `style="${newStyle}"`);
        } else {
          return match.replace(/\s*style="[^"]*"/, '');
        }
      });

      return html;
    }
  },
  mounted() {
    this.processEditorContent();
  },
  watch: {
    'data.content': {
      handler() {
        this.$nextTick(() => {
          this.processEditorContent();
        });
      },
      immediate: true
    }
  },
  methods: {
    processEditorContent() {
      const contentElement = this.$el.querySelector('.editor-block__content');
      if (contentElement) {
        this.fixMediaElements(contentElement);
        this.makeTablesResponsive(contentElement);
        this.fixLists(contentElement);
        this.fixTextAlignment(contentElement);
        this.fixIndentation(contentElement);
      }
    },

    fixIndentation(container) {
      const indentElements = container.querySelectorAll('[class*="ql-indent-"]');
      indentElements.forEach(el => {
        if (el.classList.contains('ql-indent-1')) {
          el.style.paddingLeft = '3em';
        } else if (el.classList.contains('ql-indent-2')) {
          el.style.paddingLeft = '6em';
        } else if (el.classList.contains('ql-indent-3')) {
          el.style.paddingLeft = '9em';
        } else if (el.classList.contains('ql-indent-4')) {
          el.style.paddingLeft = '12em';
        } else if (el.classList.contains('ql-indent-5')) {
          el.style.paddingLeft = '15em';
        } else if (el.classList.contains('ql-indent-6')) {
          el.style.paddingLeft = '18em';
        } else if (el.classList.contains('ql-indent-7')) {
          el.style.paddingLeft = '21em';
        } else if (el.classList.contains('ql-indent-8')) {
          el.style.paddingLeft = '24em';
        }
      });

      const listItems = container.querySelectorAll('li[class*="ql-indent-"]');
      listItems.forEach(item => {
        if (item.classList.contains('ql-indent-1')) {
          item.style.paddingLeft = '3em';
        } else if (item.classList.contains('ql-indent-2')) {
          item.style.paddingLeft = '6em';
        } else if (item.classList.contains('ql-indent-3')) {
          item.style.paddingLeft = '9em';
        } else if (item.classList.contains('ql-indent-4')) {
          item.style.paddingLeft = '12em';
        } else if (item.classList.contains('ql-indent-5')) {
          item.style.paddingLeft = '15em';
        } else if (item.classList.contains('ql-indent-6')) {
          item.style.paddingLeft = '18em';
        } else if (item.classList.contains('ql-indent-7')) {
          item.style.paddingLeft = '21em';
        } else if (item.classList.contains('ql-indent-8')) {
          item.style.paddingLeft = '24em';
        }
      });
    },

    fixMediaElements(container) {
      const images = container.querySelectorAll('img');
      images.forEach(img => {
        img.removeAttribute('data-width');
        img.removeAttribute('data-height');
        img.style.cursor = '';

        if (!img.style.width || img.style.width === '0px') {
          img.style.width = '';
        }

        img.style.maxWidth = '100%';
        img.style.height = 'auto';

        // Проверяем оба способа выравнивания
        const align = img.getAttribute('data-align');

        // Проверяем, не обернуто ли изображение в span с классом выравнивания от blotFormatter2
        const parentSpan = img.closest('span[class*="ql-image-align"]');
        let effectiveAlign = align;

        if (parentSpan) {
          if (parentSpan.classList.contains('ql-image-align-left')) {
            effectiveAlign = 'left';
          } else if (parentSpan.classList.contains('ql-image-align-center')) {
            effectiveAlign = 'center';
          } else if (parentSpan.classList.contains('ql-image-align-right')) {
            effectiveAlign = 'right';
          }

          // Устанавливаем data-align на img
          img.setAttribute('data-align', effectiveAlign);

          // Извлекаем изображение из span-обертки
          parentSpan.parentNode.insertBefore(img, parentSpan);
          parentSpan.remove();

          // Удаляем <p> вокруг изображения, если он пустой
          const parentP = img.parentNode;
          if (parentP && parentP.tagName === 'P' && !parentP.textContent.trim()) {
            parentP.parentNode.insertBefore(img, parentP);
            parentP.remove();
          }
        }

        if (effectiveAlign) {
          this.applyAlignment(img, effectiveAlign);
        } else {
          // Fallback на старые методы
          if (img.style.float === 'left') {
            this.applyAlignment(img, 'left');
          } else if (img.style.float === 'right') {
            this.applyAlignment(img, 'right');
          } else if (img.style.display === 'block' && img.style.margin === '10px auto') {
            this.applyAlignment(img, 'center');
          }
        }
      });

      // ИСПРАВЛЕННАЯ обработка видео
      const videos = container.querySelectorAll('.custom-video-container');
      videos.forEach(container => {
        // Удаляем лишние атрибуты
        container.removeAttribute('data-width');
        container.removeAttribute('data-height');
        container.style.cursor = '';

        // Получаем выравнивание из data-align или класса
        let align = container.getAttribute('data-align');

        // Если нет data-align, проверяем класс
        if (!align) {
          if (container.classList.contains('ql-image-align-left')) {
            align = 'left';
          } else if (container.classList.contains('ql-image-align-center')) {
            align = 'center';
          } else if (container.classList.contains('ql-image-align-right')) {
            align = 'right';
          }
        }

        // Устанавливаем max-width для контейнера
        container.style.maxWidth = '100%';

        // Обрабатываем видео внутри контейнера
        const video = container.querySelector('video');
        if (video) {
          video.style.maxWidth = '100%';
          video.style.height = 'auto';

          // Если у видео указана фиксированная высота, удаляем её
          if (video.style.height && video.style.height !== 'auto') {
            video.style.height = 'auto';
          }
        }

        // Применяем выравнивание
        if (align) {
          this.applyAlignment(container, align);
        } else {
          // Проверяем инлайн-стили, если нет атрибута align
          if (container.style.float === 'left') {
            this.applyAlignment(container, 'left');
          } else if (container.style.float === 'right') {
            this.applyAlignment(container, 'right');
          } else if (container.style.display === 'block' && container.style.margin === '0px auto 20px') {
            this.applyAlignment(container, 'center');
          }
        }
      });
    },

    applyAlignment(element, align) {
      element.style.float = '';
      element.style.display = '';
      element.style.margin = '';

      switch(align) {
        case 'left':
          element.style.float = 'left';
          element.style.margin = '0 20px 20px 0';
          element.style.maxWidth = '100%';
          break;
        case 'right':
          element.style.float = 'right';
          element.style.margin = '0 0 20px 20px';
          element.style.maxWidth = '100%';
          break;
        case 'center':
          element.style.display = 'block';
          element.style.margin = '20px auto';
          element.style.maxWidth = '100%';
          break;
      }
    },

    fixLists(container) {
      const lists = container.querySelectorAll('ol, ul');
      lists.forEach(list => {
        list.style.paddingLeft = '1.5em';

        const items = list.querySelectorAll('li');
        items.forEach(item => {
          const uiElements = item.querySelectorAll('.ql-ui');
          uiElements.forEach(ui => ui.style.display = 'none');
        });
      });
    },

    fixTextAlignment(container) {
      // Обрабатываем элементы с классами выравнивания от Quill
      const elements = container.querySelectorAll('[class*="ql-align"]');
      elements.forEach(el => {
        if (el.classList.contains('ql-align-right')) {
          el.style.textAlign = 'right';
        } else if (el.classList.contains('ql-align-center')) {
          el.style.textAlign = 'center';
        } else if (el.classList.contains('ql-align-justify')) {
          el.style.textAlign = 'justify';
        }
      });

      // Обрабатываем изображения с data-align
      const mediaElements = container.querySelectorAll('[data-align]');
      mediaElements.forEach(el => {
        const align = el.getAttribute('data-align');
        if (el.tagName === 'IMG' || el.classList.contains('custom-video-container')) {
          this.applyAlignment(el, align);
        }
      });

      // Обрабатываем span-обертки от blotFormatter2
      const imageSpans = container.querySelectorAll('span[class*="ql-image-align"]');
      imageSpans.forEach(span => {
        const img = span.querySelector('img');
        if (img && span.parentNode) {
          // Определяем выравнивание по классу спана
          let align = 'center';
          if (span.classList.contains('ql-image-align-left')) {
            align = 'left';
          } else if (span.classList.contains('ql-image-align-center')) {
            align = 'center';
          } else if (span.classList.contains('ql-image-align-right')) {
            align = 'right';
          }

          // Извлекаем изображение и применяем выравнивание
          span.parentNode.insertBefore(img, span);
          span.remove();
          this.applyAlignment(img, align);
        }
      });
    },

    makeTablesResponsive(container) {
      const tables = container.querySelectorAll('table');
      tables.forEach(table => {
        if (!table.parentElement.classList.contains('table-wrapper')) {
          const wrapper = document.createElement('div');
          wrapper.className = 'table-wrapper';
          table.parentNode.insertBefore(wrapper, table);
          wrapper.appendChild(table);
        }
        table.classList.add('editor-table');
      });
    }
  }
};
</script>

<style lang="scss">
.editor-block__container {
  /* Перебиваем глобальный [class*="__container"] { padding: 20px 45px } */
  max-width: none;
  width: 100%;
  margin: 0;
  padding: 0 !important;
}

.editor-block__content {
  max-width: 1650px;
  margin: 0 0;
  font-family: 'Circe', Arial, sans-serif;
  font-size: 16px;
  line-height: 1.6;
  color: #333;
  background-color: white;
  border-radius: 0;
  padding: 0;
  overflow: visible;

  .ql-indent-1 { padding-left: 3em; }
  .ql-indent-2 { padding-left: 6em; }
  .ql-indent-3 { padding-left: 9em; }
  .ql-indent-4 { padding-left: 12em; }
  .ql-indent-5 { padding-left: 15em; }
  .ql-indent-6 { padding-left: 18em; }
  .ql-indent-7 { padding-left: 21em; }
  .ql-indent-8 { padding-left: 24em; }

  li {
    &.ql-indent-1 { padding-left: 3em; }
    &.ql-indent-2 { padding-left: 6em; }
    &.ql-indent-3 { padding-left: 9em; }
    &.ql-indent-4 { padding-left: 12em; }
    &.ql-indent-5 { padding-left: 15em; }
    &.ql-indent-6 { padding-left: 18em; }
    &.ql-indent-7 { padding-left: 21em; }
    &.ql-indent-8 { padding-left: 24em; }
  }

  p {
    &.ql-indent-1 { padding-left: 3em; }
    &.ql-indent-2 { padding-left: 6em; }
    &.ql-indent-3 { padding-left: 9em; }
    &.ql-indent-4 { padding-left: 12em; }
    &.ql-indent-5 { padding-left: 15em; }
    &.ql-indent-6 { padding-left: 18em; }
    &.ql-indent-7 { padding-left: 21em; }
    &.ql-indent-8 { padding-left: 24em; }
  }

  * {
    box-sizing: border-box;
  }

  strong, b {
    font-weight: 700 !important;
  }

  em, i {
    font-style: italic !important;
  }

  u {
    text-decoration: underline !important;
  }

  s, strike {
    text-decoration: line-through !important;
  }

  h1 {
    font-size: 32px;
    line-height: 1.2;
    font-weight: 600;
    margin: 1.2em 0 0.5em;
  }

  h2 {
    font-size: 28px;
    line-height: 1.3;
    font-weight: 600;
    margin: 1.1em 0 0.5em;
  }

  h3 {
    font-size: 24px;
    line-height: 1.3;
    font-weight: 600;
    margin: 1em 0 0.5em;
  }

  h4 {
    font-size: 20px;
    line-height: 1.4;
    font-weight: 600;
    margin: 0.9em 0 0.5em;
  }

  h5 {
    font-size: 18px;
    line-height: 1.4;
    font-weight: 600;
    margin: 0.8em 0 0.4em;
  }

  h6 {
    font-size: 16px;
    line-height: 1.4;
    font-weight: 600;
    margin: 0.7em 0 0.4em;
  }

  .ql-align-right {
    text-align: right;
  }

  .ql-align-center {
    text-align: center;
  }

  .ql-align-justify {
    text-align: justify;
  }

  p {
    margin: 0 0 0;
    position: relative;
    overflow: visible;

    &:last-child {
      margin-bottom: 0;
    }
  }

  ol, ul {
    margin: 1em 0 !important;
    padding-left: 0 !important;
    list-style: none !important;
    counter-reset: list-counter;
  }

  li {
    display: flex;
    align-items: center;
    gap: 10px;
    margin: 0.5em 0 !important;

    .ql-ui {
      display: none !important;
    }
  }

  li::before {
    flex-shrink: 0;
  }

  li[data-list="bullet"]::before {
    content: "";
    width: 10px;
    height: 10px;
    background-color: #336633;
    border-radius: 50%;
  }

  ol {
    counter-reset: list-counter;
  }

  li[data-list="ordered"] {
    counter-increment: list-counter;
  }

  li[data-list="ordered"]::before {
    content: counter(list-counter) ".";
    min-width: 26px;
    text-align: right;
    font-weight: 600;
    line-height: inherit;
    display: inline-block;
  }

  ol ol, ul ul, ol ul, ul ol {
    margin: 0.4em 0 !important;
    padding-left: 25px !important;
  }

  ol ol li[data-list="ordered"]::before {
    content: counter(list-counter, lower-alpha) ".";
  }

  ol ol ol li[data-list="ordered"]::before {
    content: counter(list-counter, lower-roman) ".";
  }

  img {
    max-width: 100%;
    height: auto;

    &[data-align="left"] {
      float: left;
      margin: 0 20px 20px 0;
      max-width: 100%;
    }

    &[data-align="right"] {
      float: right;
      margin: 0 0 20px 20px;
      max-width: 100%;
    }

    &[data-align="center"] {
      display: block;
      margin: 20px auto;
      max-width: 100%;
    }
  }

  .custom-video-container {
    max-width: 100%;

    video {
      max-width: 100%;
      height: auto;
      display: block;
    }

    &[data-align="left"] {
      float: left;
      margin: 0 20px 20px 0;
      max-width: 100%;
    }

    &[data-align="right"] {
      float: right;
      margin: 0 0 20px 20px;
      max-width: 100%;
    }

    &[data-align="center"] {
      display: block;
      margin: 20px auto;
      max-width: 100%;
    }
  }

  a {
    color: #4a90e2;
    text-decoration: none;

    &:hover {
      text-decoration: underline;
    }
  }

  table {
    width: 100%;
    border-collapse: collapse;
    border: 1px solid #e0e0e0;
    margin: 1.5em 0;
    font-size: 14px;
  }

  thead {
    background-color: #f5f5f5;
  }

  th {
    border: 1px solid #e0e0e0;
    padding: 12px 16px;
    text-align: left;
    font-weight: 600;
    color: #333;
    background-color: #f8f8f8;
  }

  td {
    border: 1px solid #e0e0e0;
    padding: 10px 16px;
    text-align: left;
    vertical-align: top;
  }

  tr:nth-child(even) {
    background-color: #fafafa;
  }

  tr:hover {
    background-color: #f0f0f0;
  }

  .table-wrapper {
    overflow-x: auto;
    margin: 1.5em 0;
    -webkit-overflow-scrolling: touch;

    table {
      margin: 0;
      min-width: 600px;
    }
  }

  &::after {
    content: "";
    display: table;
    clear: both;
  }

  // Поддержка изображений с data-align
  img[data-align="left"],
  .custom-video-container[data-align="left"] {
    float: left;
    margin: 0 20px 20px 0;
    max-width: 100%;
  }

  img[data-align="right"],
  .custom-video-container[data-align="right"] {
    float: right;
    margin: 0 0 20px 20px;
    max-width: 100%;
  }

  img[data-align="center"],
  .custom-video-container[data-align="center"] {
    display: block;
    margin: 20px auto;
    max-width: 100%;
  }

  // Поддержка изображений от blotFormatter2 (на случай если span не удалился)
  span[class*="ql-image-align"] {
    display: block;

    img {
      max-width: 100%;
      height: auto;
    }
  }

  span.ql-image-align-left {
    text-align: left;

    img {
      display: inline-block;
      float: left;
      margin: 0 20px 20px 0;
    }
  }

  span.ql-image-align-center {
    text-align: center;

    img {
      display: inline-block;
      margin: 20px auto;
    }
  }

  span.ql-image-align-right {
    text-align: right;

    img {
      display: inline-block;
      float: right;
      margin: 0 0 20px 20px;
    }
  }
}

@media (max-width: 1024px) {
  .editor-block__content {
    padding: 0;
    font-size: 15px;
    word-wrap: break-word;
    overflow-wrap: break-word;
    word-break: break-word;
    hyphens: auto;

    h1 { font-size: 28px; }
    h2 { font-size: 24px; }
    h3 { font-size: 22px; }
    h4 { font-size: 19px; }
    h5 { font-size: 17px; }

    table {
      font-size: 13px;
    }

    th, td {
      padding: 10px 12px;
    }

    a {
      word-break: break-all;
    }

    p, h1, h2, h3, h4, h5, h6, li, td, th {
      overflow-wrap: break-word;
      word-wrap: break-word;
      hyphens: auto;
    }

    pre, code {
      white-space: pre-wrap;
      word-break: break-all;
    }
  }
}

@media (max-width: 768px) {
  .editor-block__content {
    padding: 0;
    font-size: 14px;
    /* Текстовый блок: углы без скругления */
    border-radius: 0;

    .ql-indent-1 { padding-left: 2em; }
    .ql-indent-2 { padding-left: 4em; }
    .ql-indent-3 { padding-left: 6em; }
    .ql-indent-4 { padding-left: 8em; }
    .ql-indent-5 { padding-left: 10em; }
    .ql-indent-6 { padding-left: 12em; }
    .ql-indent-7 { padding-left: 14em; }
    .ql-indent-8 { padding-left: 16em; }

    li, p {
      &.ql-indent-1 { padding-left: 2em; }
      &.ql-indent-2 { padding-left: 4em; }
      &.ql-indent-3 { padding-left: 6em; }
      &.ql-indent-4 { padding-left: 8em; }
      &.ql-indent-5 { padding-left: 10em; }
      &.ql-indent-6 { padding-left: 12em; }
      &.ql-indent-7 { padding-left: 14em; }
      &.ql-indent-8 { padding-left: 16em; }
    }

    h1 { font-size: 24px; }
    h2 { font-size: 22px; }
    h3 { font-size: 20px; }
    h4 { font-size: 18px; }
    h5 { font-size: 16px; }
    h6 { font-size: 15px; }

    ol, ul {
      padding-left: 1.5em !important;
    }


    img[data-align="left"],
    img[data-align="right"],
    .custom-video-container[data-align="left"],
    .custom-video-container[data-align="right"] {
      max-width: 40% !important;
    }

    th, td {
      padding: 8px 10px;
    }
  }
}

@media (max-width: 480px) {
  .editor-block__content {
    padding: 0;
    font-size: 14px;
    /* Текстовый блок: углы без скругления */
    border-radius: 0;
    overflow-x: hidden;

    .ql-indent-1 { padding-left: 1.5em; }
    .ql-indent-2 { padding-left: 3em; }
    .ql-indent-3 { padding-left: 4.5em; }
    .ql-indent-4 { padding-left: 6em; }
    .ql-indent-5 { padding-left: 7.5em; }
    .ql-indent-6 { padding-left: 9em; }
    .ql-indent-7 { padding-left: 10.5em; }
    .ql-indent-8 { padding-left: 12em; }

    li, p {
      &.ql-indent-1 { padding-left: 1.5em; }
      &.ql-indent-2 { padding-left: 3em; }
      &.ql-indent-3 { padding-left: 4.5em; }
      &.ql-indent-4 { padding-left: 6em; }
      &.ql-indent-5 { padding-left: 7.5em; }
      &.ql-indent-6 { padding-left: 9em; }
      &.ql-indent-7 { padding-left: 10.5em; }
      &.ql-indent-8 { padding-left: 12em; }
    }

    h1 {
      font-size: 22px;
      word-break: break-word;
    }
    h2 {
      font-size: 20px;
      word-break: break-word;
    }
    h3 {
      font-size: 18px;
      word-break: break-word;
    }
    h4 {
      font-size: 17px;
      word-break: break-word;
    }
    h5 {
      font-size: 15px;
      word-break: break-word;
    }
    h6 {
      font-size: 14px;
      word-break: break-word;
    }


    p {
      margin: 0 0 0.8em;
      word-break: break-word;
      overflow-wrap: break-word;
    }

    li {
      word-break: break-word;
      overflow-wrap: break-word;
    }

    img[data-align="left"],
    img[data-align="right"],
    .custom-video-container[data-align="left"],
    .custom-video-container[data-align="right"] {
      float: none !important;
      display: block !important;
      margin: 20px auto !important;
      max-width: 100% !important;
    }

    ol, ul {
      padding-left: 1.2em !important;
    }

    table {
      font-size: 12px;
    }

    th, td {
      padding: 6px 8px;
      word-break: break-word;
      overflow-wrap: break-word;
    }
  }
}

@media (max-width: 360px) {
  .editor-block__content {
    padding: 0;

    h1 { font-size: 20px; }
    h2 { font-size: 18px; }
    h3 { font-size: 17px; }
    h4 { font-size: 16px; }

    ol, ul {
      padding-left: 1em !important;
    }
  }
}


</style>